import React from "react";
import "../AskedQuestion/NewAskedQuestion.css";
import "../Technology/AllBanner/DatabaseBanner.css";

const ServicesWebFQA = () => {
  return (
    //         <div>
    //              <div className="container position-relative">
    //         <div className="faq-box p-4 p-md-5 rounded-3">
    //           <div className="text-center mb-4 mb-md-5">
    //             <h2 className=" display-6">Frequently Asked Question</h2>
    //             <p className="text-muted mb-0">
    //               We are more than a generic agency. Explore our Services and our Solutions for your
    //               business.
    //             </p>
    //           </div>

    //           <div className="row">
    //             <div className="col-lg-10 mx-auto">
    //               <div className="accordion custom-accordion" id="faqAccordion">

    //                 {/* FAQ 1 */}
    //                 <div className="accordion-item faq-item">
    //                   <h2 className="accordion-header" id="faqHeadingOne">
    //                     <button
    //                       className="accordion-button  d-flex align-items-center"
    //                       type="button"
    //                       data-bs-toggle="collapse"
    //                       data-bs-target="#faqCollapseOne"
    //                       aria-expanded="true"
    //                       aria-controls="faqCollapseOne"
    //                     >
    //                       <span className="faq-num me-3  fs-4 ">01</span>
    //                       <span className="faq-question ">
    //                        How does <span className="fw-bold">Quad Theory Ltd</span> Ltd.  ensure the quality of their offshore developer services?
    //                       </span>
    //                     </button>
    //                   </h2>
    //                   <div
    //                     id="faqCollapseOne"
    //                     className="accordion-collapse collapse show"
    //                     aria-labelledby="faqHeadingOne"
    //                     data-bs-parent="#faqAccordion"
    //                   >
    //                     <div className="accordion-body text-muted mx-5">

    // Quad Theory Ltd. maintains the highest standards through rigorous quality assurance practices, agile methodologies, and continuous code reviews. Our experienced developers and dedicated project managers ensure that every deliverable meets global quality benchmarks and client expectations.
    //                     </div>
    //                   </div>
    //                 </div>

    //                 {/* FAQ 2 */}
    //                 <div className="accordion-item faq-item">
    //                   <h2 className="accordion-header" id="faqHeadingTwo">
    //                     <button
    //                       className="accordion-button collapsed d-flex align-items-center"
    //                       type="button"
    //                       data-bs-toggle="collapse"
    //                       data-bs-target="#faqCollapseTwo"
    //                       aria-expanded="false"
    //                       aria-controls="faqCollapseTwo"
    //                     >
    //                       <span className="faq-num me-3  fs-4 ">02</span>
    //                       <span className="faq-question ">
    //                       Can businesses scale their offshore development teams with  <span className="fw-bold">Quad Theory Ltd .</span> ?
    //                       </span>
    //                     </button>
    //                   </h2>
    //                   <div
    //                     id="faqCollapseTwo"
    //                     className="accordion-collapse collapse"
    //                     aria-labelledby="faqHeadingTwo"
    //                     data-bs-parent="#faqAccordion"
    //                   >
    //                     <div className="accordion-body text-muted mx-5">
    //                   Yes, absolutely. Quad Theory Ltd. provides flexible team scaling options, allowing clients to quickly expand or downsize their offshore development teams as project demands change. Whether you need a single developer or a full dedicated team, we make scaling smooth and efficient.
    //                     </div>
    //                   </div>
    //                 </div>

    //                 {/* FAQ 3 */}
    //                 <div className="accordion-item faq-item">
    //                   <h2 className="accordion-header" id="faqHeadingThree">
    //                     <button
    //                       className="accordion-button collapsed d-flex align-items-center"
    //                       type="button"
    //                       data-bs-toggle="collapse"
    //                       data-bs-target="#faqCollapseThree"
    //                       aria-expanded="false"
    //                       aria-controls="faqCollapseThree"
    //                     >
    //                       <span className="faq-num me-3  fs-4 ">03</span>
    //                       <span className="faq-question ">
    //                        Can  <span className="fw-bold">Quad Theory Ltd .</span>redesign my existing website?
    //                       </span>
    //                     </button>
    //                   </h2>
    //                   <div
    //                     id="faqCollapseThree"
    //                     className="accordion-collapse collapse"
    //                     aria-labelledby="faqHeadingThree"
    //                     data-bs-parent="#faqAccordion"
    //                   >
    //                     <div className="accordion-body text-muted mx-5">
    //                    Of course! Quad Theory Ltd. specializes in modern website redesigns that focus on better performance, user experience, and brand consistency. We analyze your current website's structure, user journey, and design, then craft a modern, responsive, and conversion-focused version.
    //                     </div>
    //                   </div>
    //                 </div>

    //                 {/* FAQ 4 */}
    //                 <div className="accordion-item faq-item">
    //                   <h2 className="accordion-header" id="faqHeadingFour">
    //                     <button
    //                       className="accordion-button collapsed d-flex align-items-center"
    //                       type="button"
    //                       data-bs-toggle="collapse"
    //                       data-bs-target="#faqCollapseFour"
    //                       aria-expanded="false"
    //                       aria-controls="faqCollapseFour"
    //                     >
    //                       <span className="faq-num me-3  fs-4 ">04</span>
    //                       <span className="faq-question ">
    //                   Is there a specific industry focus for  <span className="fw-bold">Quad Theory Ltd .</span> 's offshore developer services?
    //                       </span>
    //                     </button>
    //                   </h2>
    //                   <div
    //                     id="faqCollapseFour"
    //                     className="accordion-collapse collapse"
    //                     aria-labelledby="faqHeadingFour"
    //                     data-bs-parent="#faqAccordion"
    //                   >
    //                     <div className="accordion-body text-muted mx-5">
    //      While our expertise spans across multiple sectors, we have strong experience in e-commerce, SaaS, healthcare, logistics, fintech, and on-demand service platforms. Our versatile team adapts to your industry's unique challenges and delivers tailored, high-impact solutions.
    //                     </div>
    //                   </div>
    //                 </div>

    //                 {/* FAQ 5 */}
    //                 <div className="accordion-item faq-item">
    //                   <h2 className="accordion-header" id="faqHeadingFive">
    //                     <button
    //                       className="accordion-button collapsed d-flex align-items-center"
    //                       type="button"
    //                       data-bs-toggle="collapse"
    //                       data-bs-target="#faqCollapseFive"
    //                       aria-expanded="false"
    //                       aria-controls="faqCollapseFive"
    //                     >
    //                       <span className="faq-num me-3  fs-4">05</span>
    //                       <span className="faq-question ">
    //                       What communication channels are used for offshore collaborations with  <span className="fw-bold">Quad Theory Ltd .</span>
    //                       </span>
    //                     </button>
    //                   </h2>
    //                   <div
    //                     id="faqCollapseFive"
    //                     className="accordion-collapse collapse"
    //                     aria-labelledby="faqHeadingFive"
    //                     data-bs-parent="#faqAccordion"
    //                   >
    //                     <div className="accordion-body text-muted mx-5">
    //                We maintain seamless collaboration through Slack, Microsoft Teams, Zoom, Google Meet, and Jira for project management. Transparent communication, regular updates, and agile sprint reviews ensure every client stays connected and informed throughout the development cycle.
    //                     </div>
    //                   </div>
    //                 </div>

    //               </div>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //         </div>

    <div id="f&q">
      <div
        id="faq"
        style={{ zIndex: 2, background: "#FAFAFA" }}
        className="faq-section position-relative"
      >
        <div className="faq-box p-4 p-md-5 rounded-3">
          <div className="text-center mb-4 mb-md-5">
            <h2 className="fw-semibold Tech-heading  display-6">
              Questions We Usually Discuss Before Building A Website
            </h2>
            <p className="text-muted database-text mb-0">
              We are more than a generic agency. Explore our Services and our
              Solutions for your business.
            </p>
          </div>

          <div className="row">
            <div className="col-12 col-lg-10 mx-auto">
              <div className="accordion custom-accordion" id="faqAccordion">
                {/* FAQ 1 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header " id="faqHeadingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseOne"
                      aria-expanded="true"
                      aria-controls="faqCollapseOne"
                    >
                      <span className="faq-num me-4 fw-semibold three">01</span>
                      <span className="faq-question  fqa-heading">
                        How is your web development different from using
                        templates or page builders?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="faqHeadingOne"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body small fqa-text text-muted px-3 px-md-5 ms-5 "
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      Templates are made to work for everybody and that
                      typically means they fit nobody perfectly. We construct
                      custom websites using your content structure, traffic
                      patterns and integrations, so the website supports the way
                      your business really works instead of making workarounds
                      later down the line.
                    </div>
                  </div>
                </div>

                {/* FAQ 2 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header" id="faqHeadingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseTwo"
                      aria-expanded="false"
                      aria-controls="faqCollapseTwo"
                    >
                      <span className="faq-num me-4 fw-semibold three">02</span>
                      <span className="faq-question  fqa-heading">
                        Will our internal team be able to manage the website
                        after launch?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqHeadingTwo"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body fqa-text small text-muted px-3 px-md-5 ms-5"
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      Yes, and this is something that we plan for very early. We
                      plan the content structure to allow marketing or
                      operations teams to be confident in updating pages without
                      destroying layouts or requiring developer assistance with
                      routine updates.
                    </div>
                  </div>
                </div>

                {/* FAQ 3 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header" id="faqHeadingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseThree"
                      aria-expanded="false"
                      aria-controls="faqCollapseThree"
                    >
                      <span className="faq-num me-4 fw-semibold three">03</span>
                      <span className="faq-question fqa-heading ">
                        Can you improve or rebuild an existing website instead
                        of starting from scratch?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqHeadingThree"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body fqa-text small text-muted px-3 ms-5 px-md-5"
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      In many cases, yes. We go through your current website and
                      ask what is still working and still causing issues as well
                      as where the website needs improvement in terms of
                      performance or structure, before suggesting that a rebuild
                      is required.
                    </div>
                  </div>
                </div>

                {/* FAQ 4 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header" id="faqHeadingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseFour"
                      aria-expanded="false"
                      aria-controls="faqCollapseFour"
                    >
                      <span className="faq-num me-4 fw-semibold three">04</span>
                      <span className="faq-question  fqa-heading">
                        How do you ensure the website stays fast as traffic
                        grows?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqHeadingFour"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body fqa-text small text-muted px-3 ms-5 px-md-5"
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      Speed is not an afterthought for us. We plan out our
                      performance at the architecture level, optimise the assets
                      and test the assets under circumstances that reflect real
                      traffic so that the site is responsive as the usage
                      increases.
                    </div>
                  </div>
                </div>

                {/* FAQ 5 */}
                <div className="accordion-item faq-item">
                  <h2 className="accordion-header" id="faqHeadingFive">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#faqCollapseFive"
                      aria-expanded="false"
                      aria-controls="faqCollapseFive"
                    >
                      <span className="faq-num me-4 fw-semibold  three">
                        05
                      </span>
                      <span className="faq-question fqa-heading">
                        What kind of involvement do you expect from us during
                        the project?
                      </span>
                    </button>
                  </h2>
                  <div
                    id="faqCollapseFive"
                    className="accordion-collapse collapse"
                    aria-labelledby="faqHeadingFive"
                    data-bs-parent="#faqAccordion"
                  >
                    <div
                      className="accordion-body small fqa-text text-muted ms-5 px-3 px-md-5"
                      style={{ textAlign: "justify", maxWidth: "85%" }}
                    >
                      We keep involvement focused. You assist with direction and
                      decisions, but not day-to-day task management. Most
                      clients like that you have visibility, but they don't want
                      to be sucked into constant meetings.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicesWebFQA;
